import {Search} from "@Views/Screening/utility/apiAgent";
export function pushFileInDocumentTable(file) {
    this.filesForDocumentTable.push({
        id: file.id,
        name: file.name,
        fileURL: file.fileURL,
        uploaded_on: file.uploadedOn || new Date()
    });

}
export function saveScreeningSearch(candidateId, requestBody) {
    const body = {
        ...requestBody,
        result_matched: requestBody.result_matched === 'yes' ? 1 : 0,
        result_status: requestBody.result_status === 'yes' ? 1 : 0,
    };
    Search.saveScreeningSearch(candidateId, body)
        .then(({ response }) => {
            this.$toastr.s('Submitted!');
            this.$hub.$emit('updateSearchItems')
        });


}